<template>
  <span class="label" :style="{ backgroundColor: color }">{{ text }}</span>
</template>
 
<script>
import { orgtypes } from '../data'
 
export default {
  name: 'orgtype-label',
  props: {
    target: {
      type: String,
      default:''
    }
  },
  computed: {
    text: function() {
      var self=this;
      var result = orgtypes.find(obj => {
        return obj.label === self.target
      })
      if(result)
       return result.label;
       else return '';
    

    },
    color: function() {
      var self=this;
       var result = orgtypes.find(obj => {
        return obj.label === self.target
      })
      
       if(result)
       return result.color;
       else return '';
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/OrgtypeLabel.vue